import { RenderClient } from 'src/components/RenderClient'
import { DropdownMenu } from './DropdownMenu/DropdownMenu'
import { Store } from './Store/Store'

export const SubHeader = () => {
  return (
    <div className="bg-white border-b border-solid border-[#E2E2E2] hidden lg:block lg:px-10 lg:py-3 relative global-subheader">
      <div className="flex flex-row justify-between items-center gap-6">
        <RenderClient>
          <Store />
        </RenderClient>
        <DropdownMenu />
      </div>
    </div>
  )
}
